<div class="adc-alert adc-align-items-center" ngClass="{{ data.customClass }}" *ngIf="type=='message'" [ngClass]="theme=='success' ? 'adc-alert-success' : theme=='info' ? 'adc-alert-info' : theme=='warning' ? 'adc-alert-warning' : theme=='danger' ? 'adc-alert-danger' : ''">
    <div class="adc-alert-msg">
        <!-- <mat-icon class="adc-size-15">{{data.icon}}</mat-icon> -->
        <img [src]="data.icon" alt="" width="15px" height="15px">
        <p class="adc-m0">{{data.message}}</p>
    </div>
    <!-- <mat-icon class="adc-size-10 adc-cursor-pointer">close</mat-icon> -->
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="15px" class="adc-cursor-pointer"><title>close</title><path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" /></svg>
</div>

<div class="adc-alert adc-alert-success" ngClass="{{ data.customClass }}" *ngIf="type=='messageWithTitle'" [ngClass]="theme=='success' ? 'adc-alert-success' : theme=='info' ? 'adc-alert-info' : theme=='warning' ? 'adc-alert-warning' : theme=='danger' ? 'adc-alert-danger' : ''">
    <div class="adc-alert-msgwttl">
        <!-- <mat-icon class="adc-size-15">{{data.icon}}</mat-icon> -->
        <img [src]="data.icon" alt="" width="15px" height="15px">
        <div>
            <h4 class="adc-m0">{{data.title}}</h4>
            <p class="adc-m0">{{data.message}}</p>
        </div>   
    </div>
    <!-- <mat-icon class="adc-size-10 adc-cursor-pointer">close</mat-icon> -->
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="15px" class="adc-cursor-pointer"><title>close</title><path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" /></svg>
</div>